import react from 'react';
import { useSnackbar } from 'notistack';
import { Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Zoom from '@material-ui/core/Zoom';

export default function useAlert() {
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const defaultAction = (key) => (
		<Button onClick={() => closeSnackbar(key)}>
			<CloseIcon />
		</Button>
	);

	const callAlert = (message = '', variant = 'success', options = {}) => {
		const { autoHideDuration = 5000, vertical = 'top', horizontal = 'right', action } = options;

		enqueueSnackbar(message, {
			variant,
			autoHideDuration,
			anchorOrigin: { vertical, horizontal },
			action: action || defaultAction,
			TransitionComponent: Zoom,
			preventDuplicate: true,
			style: { maxWidth: '700px', display: 'flex', alignItems: 'center' },
		});
	};

	return callAlert;
}
